<template>
  <div class="layout-container blank">
    <main><router-view /></main>
  </div>
</template>
